// extracted by mini-css-extract-plugin
module.exports = {"root":"LeaderboardWrapper_root__PvYz_","leaderboard":"LeaderboardWrapper_leaderboard__JfK88"};